import { OFFICE_STREET_ADDRESS, INVESTOR_SUCCESS_NAME } from './constants';

// Normalize text for comparison: lowercase, strip punctuation, collapse whitespace.
const normalizeForMatch = (value) =>
    (value ?? '')
        .toLowerCase()
        .replace(/[^\w\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

// True when the billing address's street line is our office address.
export const isOfficeStreetAddress = (billingDetail) => {
    if (!billingDetail) return false;
    return normalizeForMatch(billingDetail.addressLine1) === normalizeForMatch(OFFICE_STREET_ADDRESS);
};

const matchesInvestorSuccess = (firstName, lastName) =>
    normalizeForMatch(`${firstName ?? ''} ${lastName ?? ''}`) === normalizeForMatch(INVESTOR_SUCCESS_NAME);

// True when the "Investor Success" placeholder name is on either the top-level customer name
// or the billing-address name.
export const isInvestorSuccessAccount = (accountDetail) => {
    if (!accountDetail) return false;
    const { billingDetail } = accountDetail;
    return matchesInvestorSuccess(accountDetail.firstName, accountDetail.lastName)
        || (!!billingDetail && matchesInvestorSuccess(billingDetail.firstName, billingDetail.lastName));
};

export const getAddressStr = (billingDetail, countryOptions) => {
    let address = '';
    if (billingDetail) {
        let { addressLine1, addressLine2, city, state, zip, country } = billingDetail;

        if (country != null) {
            let countryOption = countryOptions.find(option => option.value === country);
            if (countryOptions != null)
                country = countryOption?.label;
        }

        const addressComponents2 = [state, zip, country];
        const filteredAddressComponents2 = addressComponents2.filter(component => component);
        const addressTemp = filteredAddressComponents2.join(' ');

        const addressComponents = [addressLine1, addressLine2, city, addressTemp];
        const filteredAddressComponents = addressComponents.filter(component => component);
        address = filteredAddressComponents.join(', ');
    }

    return address;
}